import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

import { adminRoot } from '../../../constants/defaultValues';

const FeatureNotAvailableModal = ({ isOpen, toggle, featureLabel }) => {
  const navigate = useNavigate();

  const handleGoToPackages = () => {
    toggle();
    navigate(`${adminRoot}/settings/features`);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle} close={
        <button className="close" onClick={toggle} type="button" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      }>
        Feature Not Available
      </ModalHeader>
      <ModalBody>
        <div className="text-center py-3">
          <i className="iconsminds-box-with-folders large-icon text-warning mb-3" style={{ fontSize: '3rem' }}></i>
          <h5 className="mb-2">You haven't purchased this feature</h5>
          <p className="text-muted mb-0">
            Please go to Features to purchase the <strong>{featureLabel}</strong> feature.
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleGoToPackages}>
          Go to Features
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default FeatureNotAvailableModal;

